var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.77097, 0, 0, 0.77097, 0.0000005, 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 40.497869 5.5024 L 7.498667 5.5024 C 7.2352 5.5024 6.981867 5.553067 6.7336 5.6544 C 6.4904 5.755734 6.272533 5.8976 6.085066 6.085067 C 5.8976 6.272534 5.755733 6.490401 5.6544 6.733601 C 5.553066 6.981867 5.5024 7.235201 5.5024 7.498667 L 5.5024 40.49787 C 5.5024 40.766403 5.553066 41.019737 5.6544 41.262937 C 5.755733 41.511203 5.8976 41.72907 6.085066 41.916537 C 6.272533 42.104003 6.4904 42.24587 6.7336 42.347203 C 6.981867 42.448537 7.2352 42.499203 7.498667 42.499203 L 40.497869 42.499203 C 40.766403 42.499203 41.019736 42.448537 41.262936 42.347203 C 41.511203 42.24587 41.729069 42.104003 41.916536 41.916537 C 42.104003 41.72907 42.245869 41.511203 42.347203 41.262937 C 42.448536 41.019737 42.499203 40.766403 42.499203 40.49787 L 42.499203 7.498667 C 42.499203 7.235201 42.448536 6.981867 42.347203 6.733601 C 42.245869 6.490401 42.104003 6.272534 41.916536 6.085067 C 41.729069 5.8976 41.511203 5.755734 41.262936 5.6544 C 41.019736 5.553067 40.766403 5.5024 40.497869 5.5024 Z M 40.497869 5.5024 ",
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.77097, 0, 0, 0.77097, 0.0000005, 0)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 9.5 23.717069 L 17.981601 23.717069 L 19.395201 25.921069 L 20.920268 22.698668 L 23.463735 37.62507 L 25.384001 10.376534 L 27.309335 24.507469 L 28.550668 23.717069 L 38.501602 23.717069 ",
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.d8e66c22cd58895785dd60951e4b68e6.svg";
export { ForwardRef as ReactComponent };